import Cookies from "js-cookie";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isTokenExpired, useAppDispatch } from "../libs/Utils/customHooks";
import { logout, setUserFromToken } from "../libs/redux/auth/signinSlice";
import useDocumentTitle from "./PageTitle";

function ScrollToTop() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const pathName = useLocation().pathname;
  let documentTitle = "Cloudivi red"; // Provide a default title

  switch (true) {
    case pathName.includes("/dashboard/Message"):
      documentTitle = "Admin | Messages";
      break;
    case pathName.includes("/dashboard/users"):
      documentTitle = "Admin | Users";
      break;
    case pathName.includes("/dashboard/transactions"):
      documentTitle = "Admin | Transactions";
      break;
    case pathName.includes("/dashboard/Team"):
      documentTitle = "Admin | Team";
      break;
    case pathName.includes("/dashboard/promo-code"):
      documentTitle = "Admin | Promo code";
      break;
    case pathName.includes("/dashboard/overview"):
      documentTitle = "Admin | Overview";
      break;
    case pathName.includes("/dashboard/settings"):
      documentTitle = "Admin | Settings";
      break;
    default:
      break;
  }
  useDocumentTitle(documentTitle);
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      if (isTokenExpired(token)) {
        dispatch(logout()); // Update Redux state to logout
      } else {
        dispatch(setUserFromToken(token)); // Set valid token in Redux state
      }
    }
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

export default ScrollToTop;
